export default __webpack_public_path__ + "static/winter8-e0fac79ee7ce2d250ca7d2f3c672c9b3.webp";